// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"TextArea_text-gradient__1kh_y","label":"TextArea_label__1zevk","textarea":"TextArea_textarea__w2Yjz"};